var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"refund-change-tip-wrap"},[_vm._v(" 受抖音政策调整影响，9月3日以后的订单结算周期全部延长至履约后14天。 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }